type Input = {
  possibleScores: number[]
  score?: number
  type: 'light' | 'dark'
}

type Output = {
  color: string
  borderColor: string
  backgroundColor: string
}

const COLOR_BUCKET_COUNT = 5

/* This function divides the possible scores into 5 equal buckets based on range. Then it places the score provided
 * into its bucket. The idea is to map a score to the colour where it should fit. You can check the unit tests
 * for examples of how it works and edge cases */
export const getRiskScoreColorSx = ({ possibleScores, score = 0, type }: Input): Output => {
  if (score === 0 || possibleScores.length === 0) return tokensFor(type, 0)
  const sortedScoresWithoutZero = possibleScores.sort((a, b) => a - b).filter((score) => score !== 0)
  const totalScores = sortedScoresWithoutZero.length
  const numberOfBuckets = Math.min(COLOR_BUCKET_COUNT, totalScores)
  const minScore = sortedScoresWithoutZero[0] as number
  const maxScore = sortedScoresWithoutZero[totalScores - 1] as number
  const normalizedScore = sortedScoresWithoutZero.length === 1 ? 1 : (score - minScore) / (maxScore - minScore)
  const bucketIndex = Math.ceil(normalizedScore * (numberOfBuckets - 1) + 1) as 1 | 2 | 3 | 4 | 5

  return tokensFor(type, bucketIndex)
}

const tokensFor = (type: 'light' | 'dark', bucketIndex: 0 | 1 | 2 | 3 | 4 | 5): Output => ({
  color: `riskScore.${type}.color.${bucketIndex}`,
  borderColor: `riskScore.${type}.border.${bucketIndex}`,
  backgroundColor: `riskScore.${type}.background.${bucketIndex}`,
})
